import React, { useState, useEffect } from 'react';

const DashboardUsers = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetch('https://fusionsmart.seifeddineslimene.com/api/users', {
      method: 'GET',
      headers: {},
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => console.error('Error fetching users:', error));
  }, []);

  return (
    <div
      id='content-body'
      className='col-12'
    >
      <div className='mt-1 mb-5'>
        <table className='container-fluid'>
          <thead>
            <tr className=' text-white row'>
              <th className='col'>nom</th>
              <th className='col'>profile</th>
              <th className='col'>adresse</th>
              <th className='col'>contact</th>
              <th className='col'>email</th>
            </tr>
          </thead>
          <tbody>
            {users &&
              users.map((val) => (
                <tr key={val._id} className='row'>
                  <td className='col'>{val.profile}</td>
                  <td className='col'>{val.name}</td>
                  <td className='col'>{val.adresse}</td>
                  <td className='col'>{val.contact}</td>
                  <td className='col'>{val.email}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashboardUsers;
